import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import {
  toWidget
} from '@ckeditor/ckeditor5-widget/src/utils';
import { removeDefaultHtmlSpanAttributes } from '../../src/utils/subtemplateutils';

export default class NumberedCitationConverterCommand extends Plugin {
  constructor(editor) {
    super(editor);
    this.refresh();
  }

  execute() {
    const editor = this.editor;
    const conversion = this.editor.conversion;
    this.editor.model.schema.addAttributeCheck(context => {
      if (context.endsWith('numberedcitation')) {
        return true;
      }
    });

    conversion.for('upcast').elementToElement({
      view: {
        name: 'span',
        classes: ['numbered-citation']
      },
      model: (viewElement, { writer: modelWriter }) => {
        const text = viewElement.getChild(0);
        return modelWriter.createElement('numberedcitation', { 'data-citationcount': text });
      }
    });

    conversion.for('editingDowncast').elementToElement({
      model: 'numberedcitation',
      view: (modelItem, { writer: viewWriter }) => {
        removeDefaultHtmlSpanAttributes(modelItem, this.editor);
        const widgetElement = createPlaceholderView(modelItem, viewWriter);
        // Enable widget handling on a placeholder element inside the editing view.
        return toWidget(widgetElement, viewWriter);
      }
    });

    conversion.for('editingDowncast').elementToElement({
      model: 'span',
      view: (modelItem, { writer: viewWriter }) => {
        removeDefaultHtmlSpanAttributes(modelItem, this.editor);
        const widgetElement = createPlaceholderView(modelItem, viewWriter);
        return toWidget(widgetElement, viewWriter);
      }
    });

    conversion.for('dataDowncast').elementToElement({
      model: 'numberedcitation',
      view: (modelItem, { writer: viewWriter }) => {
        removeDefaultHtmlSpanAttributes(modelItem, this.editor);
        return createPlaceholderView(modelItem, viewWriter)
      }
    });

    conversion.for('dataDowncast').elementToElement({
      model: 'span',
      view: (modelItem, { writer: viewWriter }) => createPlaceholderView(modelItem, viewWriter)
    });

    conversion.for('downcast')
      .add(dispatcher => {
        dispatcher.on('attribute:data-citationcount', (evt, data, conversionApi) => {
          if (data.item.name == 'span' || data.item.name == 'numberedcitation') {
            if ((data.attributeOldValue !== null && data.attributeNewValue !== null)) {
              data.attributeNewValue = (data.attributeNewValue !== null) ? data.attributeNewValue : data.attributeOldValue;
              const myModelElement = data.item;
              conversionApi.consumable.consume(data.item, evt.name);
              const viewElement = conversionApi.mapper.toViewElement(myModelElement);
              conversionApi.writer.remove(viewElement.getChild(0));
              setContent(conversionApi.writer, data.attributeNewValue, viewElement);
            }
          }
        });
      });

    // Helper method for both downcast converters.
    function createPlaceholderView(modelItem, viewWriter) {
      const citationCount = modelItem.getAttribute('data-citationcount');
      const placeholderView = viewWriter.createContainerElement('span', {
        class: 'ref numbered-citation',
        id: modelItem.getAttribute('id')
      }, {
        isAllowedInsideAttributeElement: true
      });

      const innerText = viewWriter.createText(`[${citationCount}]`);
      viewWriter.insert(viewWriter.createPositionAt(placeholderView, 0), innerText);
      return placeholderView;
    }

    function setContent(writer, citationCount, placeholderView) {
      const innerText = writer.createText(`[${citationCount}]`);
      writer.insert(writer.createPositionAt(placeholderView, 0), innerText);
    }
  }

  refresh() {
  }
}